// 🚨 AUTO-GENERADO desde ExpenseNoteDataType.ts - No editar manualmente

export const ExpenseNoteFormDataKeys = [
  "id",
  "sequence",
  "document_key",
  "numero",
  "fecha",
  "tipo",
  "subtotal",
  "descuento",
  "impuestos",
  "total",
  "exchange_rate",
  "expenseId",
  "expense",
  "currencyId",
  "currency"
] as const;
